import request from "superagent";

import { getAuthHeader } from "../../utils/superagent";

const fetchAllExperiences = async (query) => {
  try {
    const { body } = await request
      .get(`${global.api}/hcpExperience?type=${query}`)
      .set(await getAuthHeader());
    return body;
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    return [];
  }
};

export { fetchAllExperiences };
